module.exports = __webpack_public_path__ + "static/media/James_Davies_ID.989b8e7d.jpg";